import React, { useEffect } from 'react';
import { Box, Form, Heading, SubmitButton, Text, useAnalytics } from '@medely/ui-kit';
import { WorkExperienceForm } from '../WorkExperienceForm';
import {
  useCurrentUserForWorkExperience,
  useLocationOptionsForWorkExperience,
} from '../../graphql';
import { LoadingState } from '../../../../components/LoadingState';
import { useWorkExperience } from '../../hooks/useWorkExperience';
import { useWorkExperienceMutations } from '../../mutations';
import { createMostRecentWorkExperienceValidation } from '../schema';
import { FormValuesProps } from '../../interface';
import { useCurrentUser } from '@mp/hooks';

type AddExperienceModalInfoProps = {
  onClose: () => void;
  hideTitle?: boolean;
};

export const AddExperienceModalInfo = ({
  onClose,
  hideTitle = false,
}: AddExperienceModalInfoProps) => {
  const analytics = useAnalytics();
  const { proType } = useCurrentUser();
  const { currentUser, currentUserLoading } = useCurrentUserForWorkExperience();
  const { locationTypesLoading } = useLocationOptionsForWorkExperience();
  const { createPayload, totalYearsOfExperience } = useWorkExperience({
    currentUser: currentUser || undefined,
  });
  const { submitWorkExperienceInfo } = useWorkExperienceMutations();

  const baseValuesLoading = currentUserLoading || locationTypesLoading;

  const handleSubmit = (values: FormValuesProps) => {
    const parsedValues = createPayload(values);
    submitWorkExperienceInfo(parsedValues, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  useEffect(() => {
    analytics.track('Product Application Add Secondary Experience  - Viewed', {
      account_id: currentUser?.id,
      context: 'Product Application Add Secondary Experience',
      subcontext: null,
      action: 'Viewed',
      pro_type: proType,
    });
  }, []);

  if (baseValuesLoading) {
    return <LoadingState />;
  }

  return (
    <Form
      handleSubmit={handleSubmit}
      schema={createMostRecentWorkExperienceValidation(totalYearsOfExperience)}
    >
      <Box pb={2}>
        {!hideTitle && (
          <Heading size="s" testId="add-experience-modal-title">
            Add experience
          </Heading>
        )}

        <Text size="m" testId="add-experience-modal-subtitle">
          Provide details for a recent position in the U.S.
        </Text>
      </Box>
      <WorkExperienceForm
        currentUser={currentUser || undefined}
        isExtraInformation={true}
        hideButtonToSummary={true}
      />
      <SubmitButton fullWidth testId="add-experience-modal-save-button">
        Save
      </SubmitButton>
    </Form>
  );
};
